import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeContactModal } from '../redux/global/globalReducer';
import ContactModal from './components/contact-modal/ContactModal';

function ContactModalHost() {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.global.isContactModalOpen);

  const handleClose = () => {
    dispatch(closeContactModal());
  };

  return <ContactModal isOpen={isOpen} onClose={handleClose} />;
}

export default ContactModalHost;
